export * from './fromu.component';

